<template>
    <div id="banner">
        <div class="flex-dis pic" ref="bannerDiv" :style="{'background-image':'url('+bannerUrl+')'}">
            <div class="pro-banner animate__animated animate__fadeInUp" v-if="bannerTitle && bannerContent && showAnimate">
                <h2 class="font-fff">{{bannerTitle}}</h2>
                <p class="font-fff-8">{{bannerContent}}</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['bannerUrl','bannerTitle','bannerContent'],
    data(){
        return {
            showAnimate: true
        }
    },
    watch: {
        bannerTitle(){
this.showAnimate = false
        setTimeout(()=>{
            this.showAnimate = true
        },50)
        }
        
    }
}
</script>
<style lang="less">
#banner{
    .pic{
        width: 100%;
        flex-direction: row;
        align-content: center;
        justify-content: center;
        align-items: flex-end;
        background-size: 100% 100%;
        background-position: top left;
        background-repeat: no-repeat;
    }
    .pro-banner{
        p,h1{
            text-align: left;
            white-space: pre-wrap
        }
        p{
             overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
        }
    }
 
}
 
</style>


// WEBPACK FOOTER //
// src/components/banner.vue